"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var _components = require("@abroad/components");

var Teams = /*#__PURE__*/function () {
  function Teams(client) {
    (0, _classCallCheck2["default"])(this, Teams);
    this.client = client;
    this.resourceUrl = '/admin';
  }

  (0, _createClass2["default"])(Teams, [{
    key: "getTeams",
    value: function getTeams(params) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.get("/team".concat(params), args);
    }
  }, {
    key: "getEcoSystemsData",
    value: function getEcoSystemsData() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.client.get("".concat(this.resourceUrl, "/ecosystem").concat(params), args);
    }
  }, {
    key: "getPromocodeData",
    value: function getPromocodeData() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.client.get("".concat(this.resourceUrl, "/promo-code"), args);
    }
  }, {
    key: "getCoachData",
    value: function getCoachData() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.client.get("/user/coaches", args);
    }
  }, {
    key: "getCompanyTeamMembers",
    value: function getCompanyTeamMembers(company) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      return this.client.get("/user/company/".concat(company, "/users?intent=").concat(_components.manageGroup), args);
    }
  }, {
    key: "getEcoSystemTeamMembers",
    value: function getEcoSystemTeamMembers(ecoSystem) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      return this.client.get("/user/ecosystem/".concat(ecoSystem, "/users?intent=").concat(_components.manageGroup), args);
    }
  }, {
    key: "getPromocodeTeamMembers",
    value: function getPromocodeTeamMembers(promoCode) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }

      return this.client.get("/user/promo-code/".concat(promoCode, "/users?intent=").concat(_components.manageGroup), args);
    }
  }, {
    key: "addTeam",
    value: function addTeam(data) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }

      return this.client.post("/team", data, args);
    }
  }, {
    key: "getSearchUsersData",
    value: function getSearchUsersData(search) {
      for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        args[_key9 - 1] = arguments[_key9];
      }

      return this.client.get("/user/search/".concat(search, "/users?intent=").concat(_components.manageGroup), args);
    }
  }, {
    key: "archivedTeam",
    value: function archivedTeam(teamId, data) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
        args[_key10 - 2] = arguments[_key10];
      }

      return this.client.put("/team/".concat(teamId), data, args);
    }
  }, {
    key: "getArchivedTeams",
    value: function getArchivedTeams(params) {
      for (var _len11 = arguments.length, args = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        args[_key11 - 1] = arguments[_key11];
      }

      return this.client.get("/team".concat(params), args);
    }
  }, {
    key: "restoreTeam",
    value: function restoreTeam(teamId) {
      for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        args[_key12 - 1] = arguments[_key12];
      }

      return this.client.put("/team/".concat(teamId, "/restore"), {}, args);
    }
  }, {
    key: "getFilteredTeams",
    value: function getFilteredTeams(params) {
      for (var _len13 = arguments.length, args = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
        args[_key13 - 1] = arguments[_key13];
      }

      return this.client.get("/team/".concat(params), args);
    }
  }, {
    key: "getTeamData",
    value: function getTeamData(teamId) {
      for (var _len14 = arguments.length, args = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
        args[_key14 - 1] = arguments[_key14];
      }

      return this.client.get("/team/".concat(teamId), args);
    }
  }, {
    key: "getTeamSpecificData",
    value: function getTeamSpecificData(teamId, data) {
      for (var _len15 = arguments.length, args = new Array(_len15 > 2 ? _len15 - 2 : 0), _key15 = 2; _key15 < _len15; _key15++) {
        args[_key15 - 2] = arguments[_key15];
      }

      return this.client.post("/team/".concat(teamId, "/selected-keys"), data, args);
    }
  }, {
    key: "updateTeam",
    value: function updateTeam(teamId, data) {
      for (var _len16 = arguments.length, args = new Array(_len16 > 2 ? _len16 - 2 : 0), _key16 = 2; _key16 < _len16; _key16++) {
        args[_key16 - 2] = arguments[_key16];
      }

      return this.client.put("/team/".concat(teamId), data, args);
    }
  }, {
    key: "getSurveyResultData",
    value: function getSurveyResultData(teamId) {
      for (var _len17 = arguments.length, args = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
        args[_key17 - 1] = arguments[_key17];
      }

      return this.client.get("/survey/team/".concat(teamId), args);
    }
  }, {
    key: "combinedResult",
    value: function combinedResult(teamId) {
      for (var _len18 = arguments.length, args = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
        args[_key18 - 1] = arguments[_key18];
      }

      return this.client.get("/survey/team/".concat(teamId), args);
    }
  }, {
    key: "getAssessmentQuaterData",
    value: function getAssessmentQuaterData(teamId) {
      for (var _len19 = arguments.length, args = new Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
        args[_key19 - 1] = arguments[_key19];
      }

      return this.client.get("/survey/quarterly-count/team/".concat(teamId), args);
    }
  }, {
    key: "getSessionListData",
    value: function getSessionListData(teamId) {
      for (var _len20 = arguments.length, args = new Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
        args[_key20 - 1] = arguments[_key20];
      }

      return this.client.get("/session/team/".concat(teamId), args);
    }
  }, {
    key: "sessionDelete",
    value: function sessionDelete(sessionId) {
      for (var _len21 = arguments.length, args = new Array(_len21 > 1 ? _len21 - 1 : 0), _key21 = 1; _key21 < _len21; _key21++) {
        args[_key21 - 1] = arguments[_key21];
      }

      return this.client["delete"]("/session/".concat(sessionId), args);
    }
  }, {
    key: "getCombinedTeamAssessment",
    value: function getCombinedTeamAssessment(teamId, quarter, year, querySurveyType) {
      for (var _len22 = arguments.length, args = new Array(_len22 > 4 ? _len22 - 4 : 0), _key22 = 4; _key22 < _len22; _key22++) {
        args[_key22 - 4] = arguments[_key22];
      }

      return this.client.get("/survey/team/".concat(teamId, "?year=").concat(year, "&quarter=").concat(quarter, "&surveyType=").concat(querySurveyType), args);
    }
  }, {
    key: "getCountByTeam",
    value: function getCountByTeam(params) {
      for (var _len23 = arguments.length, args = new Array(_len23 > 1 ? _len23 - 1 : 0), _key23 = 1; _key23 < _len23; _key23++) {
        args[_key23 - 1] = arguments[_key23];
      }

      return this.client.get("/survey/count-by-team".concat(params), args);
    }
  }, {
    key: "getSurveyDateByTeam",
    value: function getSurveyDateByTeam(teamId, params) {
      for (var _len24 = arguments.length, args = new Array(_len24 > 2 ? _len24 - 2 : 0), _key24 = 2; _key24 < _len24; _key24++) {
        args[_key24 - 2] = arguments[_key24];
      }

      return this.client.get("/survey/team/".concat(teamId, "/").concat(params), args);
    }
  }, {
    key: "getTeamComparisonReport",
    value: function getTeamComparisonReport(teamId, params) {
      for (var _len25 = arguments.length, args = new Array(_len25 > 2 ? _len25 - 2 : 0), _key25 = 2; _key25 < _len25; _key25++) {
        args[_key25 - 2] = arguments[_key25];
      }

      return this.client.get("/survey/compare/team/".concat(teamId, "/").concat(params), args);
    }
  }, {
    key: "getTeamComparisonReportCommonUsers",
    value: function getTeamComparisonReportCommonUsers(teamId, params) {
      for (var _len26 = arguments.length, args = new Array(_len26 > 2 ? _len26 - 2 : 0), _key26 = 2; _key26 < _len26; _key26++) {
        args[_key26 - 2] = arguments[_key26];
      }

      return this.client.get("/survey/team-comparison-report-with-common-user/".concat(teamId, "/").concat(params), args);
    }
  }, {
    key: "getSessionData",
    value: function getSessionData(sessionId) {
      for (var _len27 = arguments.length, args = new Array(_len27 > 1 ? _len27 - 1 : 0), _key27 = 1; _key27 < _len27; _key27++) {
        args[_key27 - 1] = arguments[_key27];
      }

      return this.client.get("/session/".concat(sessionId), args);
    }
  }, {
    key: "sessionCreate",
    value: function sessionCreate(teamId, data) {
      for (var _len28 = arguments.length, args = new Array(_len28 > 2 ? _len28 - 2 : 0), _key28 = 2; _key28 < _len28; _key28++) {
        args[_key28 - 2] = arguments[_key28];
      }

      return this.client.post("/session/team/".concat(teamId), data, args);
    }
  }, {
    key: "updateSession",
    value: function updateSession(sessionId, data) {
      for (var _len29 = arguments.length, args = new Array(_len29 > 2 ? _len29 - 2 : 0), _key29 = 2; _key29 < _len29; _key29++) {
        args[_key29 - 2] = arguments[_key29];
      }

      return this.client.put("/session/".concat(sessionId), data, args);
    }
  }, {
    key: "getSignUrlForUploadImpactReport",
    value: function getSignUrlForUploadImpactReport(contentType, teamId) {
      for (var _len30 = arguments.length, args = new Array(_len30 > 2 ? _len30 - 2 : 0), _key30 = 2; _key30 < _len30; _key30++) {
        args[_key30 - 2] = arguments[_key30];
      }

      return this.client.post("/document/3/team/".concat(teamId, "/signed-url?fileType=").concat(contentType), args);
    }
  }, {
    key: "addImpactReport",
    value: function addImpactReport(teamId, fileName) {
      for (var _len31 = arguments.length, args = new Array(_len31 > 2 ? _len31 - 2 : 0), _key31 = 2; _key31 < _len31; _key31++) {
        args[_key31 - 2] = arguments[_key31];
      }

      return this.client.post("/document/3/team/".concat(teamId), fileName, args);
    }
  }, {
    key: "getSignUrlForUploadCoachReport",
    value: function getSignUrlForUploadCoachReport(contentType, teamId) {
      for (var _len32 = arguments.length, args = new Array(_len32 > 2 ? _len32 - 2 : 0), _key32 = 2; _key32 < _len32; _key32++) {
        args[_key32 - 2] = arguments[_key32];
      }

      return this.client.post("/document/1/team/".concat(teamId, "/signed-url?fileType=").concat(contentType), args);
    }
  }, {
    key: "addcoachReport",
    value: function addcoachReport(teamId, fileName) {
      for (var _len33 = arguments.length, args = new Array(_len33 > 2 ? _len33 - 2 : 0), _key33 = 2; _key33 < _len33; _key33++) {
        args[_key33 - 2] = arguments[_key33];
      }

      return this.client.post("/document/1/team/".concat(teamId), fileName, args);
    }
  }, {
    key: "getDocumentList",
    value: function getDocumentList(teamId) {
      for (var _len34 = arguments.length, args = new Array(_len34 > 1 ? _len34 - 1 : 0), _key34 = 1; _key34 < _len34; _key34++) {
        args[_key34 - 1] = arguments[_key34];
      }

      return this.client.get("/document/team/".concat(teamId), args);
    }
  }, {
    key: "downloadReport",
    value: function downloadReport(docId, docType, fileName, type, teamId) {
      for (var _len35 = arguments.length, args = new Array(_len35 > 5 ? _len35 - 5 : 0), _key35 = 5; _key35 < _len35; _key35++) {
        args[_key35 - 5] = arguments[_key35];
      }

      return this.client.get("/document/".concat(docId, "/").concat(docType, "/team/").concat(teamId, "/signed-url?fileType=").concat(type, "&fileName=").concat(fileName), args);
    }
  }, {
    key: "deleteReport",
    value: function deleteReport(docId, teamId) {
      for (var _len36 = arguments.length, args = new Array(_len36 > 2 ? _len36 - 2 : 0), _key36 = 2; _key36 < _len36; _key36++) {
        args[_key36 - 2] = arguments[_key36];
      }

      return this.client["delete"]("/document/".concat(docId, "/team/").concat(teamId), args);
    }
  }, {
    key: "getTeamMetadata",
    value: function getTeamMetadata(teamId) {
      for (var _len37 = arguments.length, args = new Array(_len37 > 1 ? _len37 - 1 : 0), _key37 = 1; _key37 < _len37; _key37++) {
        args[_key37 - 1] = arguments[_key37];
      }

      return this.client.post("/team/".concat(teamId, "/selected-keys"), {
        fields: ['name', 'isArchived', 'groupType']
      }, args);
    }
  }, {
    key: "getClientOrTeamOption",
    value: function getClientOrTeamOption(getTeamData, data) {
      var queryString = '';

      if (getTeamData) {
        queryString = "/team/search-with-coach-filter";
      } else {
        queryString = "/user/search-with-coach-filter";
      }

      for (var _len38 = arguments.length, args = new Array(_len38 > 2 ? _len38 - 2 : 0), _key38 = 2; _key38 < _len38; _key38++) {
        args[_key38 - 2] = arguments[_key38];
      }

      return this.client.post("".concat(queryString), data, args);
    }
  }, {
    key: "getSessionInsightDataList",
    value: function getSessionInsightDataList(data) {
      for (var _len39 = arguments.length, args = new Array(_len39 > 1 ? _len39 - 1 : 0), _key39 = 1; _key39 < _len39; _key39++) {
        args[_key39 - 1] = arguments[_key39];
      }

      return this.client.post('/session/report', data, args);
    }
  }, {
    key: "exportSessionInsightsAsCSV",
    value: function exportSessionInsightsAsCSV(data) {
      for (var _len40 = arguments.length, args = new Array(_len40 > 1 ? _len40 - 1 : 0), _key40 = 1; _key40 < _len40; _key40++) {
        args[_key40 - 1] = arguments[_key40];
      }

      return this.client.post('/session/export-report', data, args);
    } // getOrganizationTeams(type, orgEcoId, ...args) {
    //   return this.client.get(`/${type}/${orgEcoId}/teams`, args)
    // }

  }, {
    key: "addOrgEcoTeam",
    value: function addOrgEcoTeam(type, orgEcoId, data) {
      for (var _len41 = arguments.length, args = new Array(_len41 > 3 ? _len41 - 3 : 0), _key41 = 3; _key41 < _len41; _key41++) {
        args[_key41 - 3] = arguments[_key41];
      }

      return this.client.post("/".concat(type, "/").concat(orgEcoId, "/teams"), data, args);
    }
  }, {
    key: "deleteOrgEcoTeam",
    value: function deleteOrgEcoTeam(type, orgEcoId, teamName) {
      for (var _len42 = arguments.length, args = new Array(_len42 > 3 ? _len42 - 3 : 0), _key42 = 3; _key42 < _len42; _key42++) {
        args[_key42 - 3] = arguments[_key42];
      }

      return this.client["delete"]("/".concat(type, "/").concat(orgEcoId, "/teams/").concat(teamName), args);
    }
  }, {
    key: "updateUserTeam",
    value: function updateUserTeam(userId, teamName) {
      for (var _len43 = arguments.length, args = new Array(_len43 > 2 ? _len43 - 2 : 0), _key43 = 2; _key43 < _len43; _key43++) {
        args[_key43 - 2] = arguments[_key43];
      }

      return this.client.put("/user/".concat(userId, "/company-team/").concat(teamName), args);
    }
  }, {
    key: "getGroupJourney",
    value: function getGroupJourney(teamId) {
      var _this$client;

      for (var _len44 = arguments.length, args = new Array(_len44 > 1 ? _len44 - 1 : 0), _key44 = 1; _key44 < _len44; _key44++) {
        args[_key44 - 1] = arguments[_key44];
      }

      return (_this$client = this.client).get.apply(_this$client, ["/journey?teamId=".concat(teamId)].concat(args));
    }
  }, {
    key: "updateGroupJourney",
    value: function updateGroupJourney(teamId, data) {
      var _this$client2;

      for (var _len45 = arguments.length, args = new Array(_len45 > 2 ? _len45 - 2 : 0), _key45 = 2; _key45 < _len45; _key45++) {
        args[_key45 - 2] = arguments[_key45];
      }

      return (_this$client2 = this.client).put.apply(_this$client2, ["/journey?teamId=".concat(teamId), data].concat(args));
    }
  }, {
    key: "getTeamName",
    value: function getTeamName(teamId) {
      for (var _len46 = arguments.length, args = new Array(_len46 > 1 ? _len46 - 1 : 0), _key46 = 1; _key46 < _len46; _key46++) {
        args[_key46 - 1] = arguments[_key46];
      }

      return this.client.post("/team/".concat(teamId, "/selected-keys"), {
        fields: ['name']
      }, args);
    }
  }, {
    key: "getAddCicle",
    value: function getAddCicle(teamId, data) {
      var _this$client3;

      for (var _len47 = arguments.length, args = new Array(_len47 > 2 ? _len47 - 2 : 0), _key47 = 2; _key47 < _len47; _key47++) {
        args[_key47 - 2] = arguments[_key47];
      }

      return (_this$client3 = this.client).post.apply(_this$client3, ["/team/".concat(teamId, "/circle"), data].concat(args));
    }
  }]);
  return Teams;
}();

exports["default"] = Teams;